export const REF_NAME = 'INSURANCECOMPANY';
export const REF_PATH = 'insurancecompany';
export const NAME = 'Insurance company';
